import { CircularProgress, Box } from "@mui/material";
import PropTypes from "prop-types";

const Loader = ({ sx = {}, size = 40 }) => {
  return (
    <Box
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 80,
        height: "100%",
        ...sx,
      }}
    >
      <CircularProgress size={size} data-testid="loader" />
    </Box>
  );
};

Loader.propTypes = {
  sx: PropTypes.object,
  size: PropTypes.number,
};

export default Loader;
